module.exports = __webpack_public_path__ + "static/img/copy-clipboard.7c47950c.svg";